<div class="row mt-4 me-5 pt-4 pb-4 align-items-center">

    <div class="buttons-holder col-3 offset-1 mt-0 mb-2">
        <button type="button" class="btn btn-black italic" [disabled]="isGenerating()"
            (click)="downloadAllInvitations()">
            {{ isGenerating() ? 'Génération...' : 'Télécharger 1 pdf complet' }}
        </button>
    </div>

    <div class="buttons-holder offset-1 col-3 mt-0 mb-2">
        <button type="button" class="btn btn-white italic" [disabled]="isGenerating()"
            (click)="downloadAllAsZip(true)">
            {{ isGenerating() ? 'Génération...' : 'Télécharger Zip des familles visibles' }}
        </button>
    </div>

    <div class="buttons-holder offset-1 col-3 mt-0 mb-2">
        <button type="button" class="btn btn-white italic" [disabled]="isGenerating()"
            (click)="downloadAllAsZip(false)">
            {{ isGenerating() ? 'Génération...' : 'Télécharger Zip complet' }}
        </button>
    </div>
</div>
